import { createAction } from '../../../core/helpers'

import {
  COMMON_FETCH_EVENTS,
  COMMON_FETCH_LATEST_EVENT_BY_ENTITY_TYPES,
} from '../action-types'

export const cleanupCommonFetchEvents = createAction(
  COMMON_FETCH_EVENTS.CLEANUP,
)

export const cleanupCommonFetchLatestEventByEntityTypes = createAction(
  COMMON_FETCH_LATEST_EVENT_BY_ENTITY_TYPES.CLEANUP,
)
